import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { UpsertModalParams } from './types'

export type AccessState = {
  upsertModalParams: UpsertModalParams | null
}

type AccessRoot = {
  access: AccessState
}

const initialState: AccessState = {
  upsertModalParams: null,
}

const accessSlice = createSlice({
  name: 'access',
  initialState,
  reducers: {
    setUpsertModalParams: (state, action: PayloadAction<UpsertModalParams>) => {
      state.upsertModalParams = action.payload;
    },
    clearUpsertModalParams: (state) => {
      state.upsertModalParams = null;
    },
  },
});

export const selectShowUpsertModal = (state: AccessRoot) =>
  !!state.access.upsertModalParams;
export const selectUpsertModalParams = (state: AccessRoot) =>
  state.access.upsertModalParams;

export const { 
  setUpsertModalParams,
  clearUpsertModalParams,
} = accessSlice.actions;

export default accessSlice.reducer;
